// Mapping from FileType to function_id for protocol chunk requests
// Update this mapping if protocol changes
import { FileType } from './file_type';

// Response Function ID (for parsing received chunks)
export const FILE_TYPE_TO_FUNCTION_ID: Record<Exclude<FileType, FileType.DATALOG>, number> = {
  [FileType.GAS]: 0x18, // Gas Data
  [FileType.EVENT]: 0x19, // Event Log
  [FileType.GEN_CONF]: 0x1a, // General Config
  [FileType.SEN_CONF]: 0x1b, // Sensor Config
  [FileType.GAS_ALARM]: 0x1c, // Gas Alarm Log
  [FileType.CAL_BUMP]: 0x1d, // Calibration/Bump Log
};

// Request Function ID (for requesting individual chunks in Normal mode or retry)
// Protocol: 0x03=Gas, 0x05=Event, 0x07=GenConf, 0x09=SenConf, 0x0B=GasAlarm, 0x0D=Cal/Bump
export const FILE_TYPE_TO_REQUEST_FUNCTION_ID: Record<
  Exclude<FileType, FileType.DATALOG>,
  number
> = {
  [FileType.GAS]: 0x03, // Request data log - Gas Reading chunk
  [FileType.EVENT]: 0x05, // Request data log - Event chunk
  [FileType.GEN_CONF]: 0x07, // Request data log - General Configuration chunk
  [FileType.SEN_CONF]: 0x09, // Request data log - Sensor Configuration chunk
  [FileType.GAS_ALARM]: 0x0b, // Request event(alarm) log chunk
  [FileType.CAL_BUMP]: 0x0d, // Request cal/bump log chunk
};
